<template>
    <div class="news-updates">
      <Layout ref="layoutRef" :selectedOption="4" />
      <h4>Actualizaciones y Noticias</h4>
      <hr>
      <ul>
        <li v-for="(item, index) in newsList" :key="index" class="news-item">
          <div @click="toggleDetails(index)" class="news-summary">
            <h3>{{ item.title }}</h3>
            <p>{{ item.summary }}</p>
            <span class="toggle-details">Click para {{ expandedIndex === index ? 'colapsar' : 'expandir' }}</span>
          </div>
          <div v-if="expandedIndex === index" class="news-details">
            <p>{{ item.details }}</p>
            <p class="news-date">Publicado: {{ item.date }}</p>
          </div>
        </li>
      </ul>
      <Footer/>
    </div>
  </template>
  
  <script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
  import { ref } from 'vue';
  
  export default {
    name: 'NewsUpdates',
    components : {
      Layout, Footer
    },
    setup() {
      const newsList = ref([
        {
          title: 'Actualización 1.2.5',
          summary: 'Esta actualización incluye mejoras de rendimiento y correcciones de errores menores.',
          details: 'Detalles de la actualización 1.2.5: Mejora en la carga de la página, correcciones en el módulo de autenticación, etc.',
          date: '2024-05-12'
        },
        {
          title: 'Nueva Característica: Chat en Vivo',
          summary: 'Introducimos nuestra nueva característica de chat en vivo para soporte técnico.',
          details: 'Ahora puedes acceder al chat en vivo desde la sección de ayuda para obtener soporte en tiempo real. Esta función está disponible para usuarios premium.',
          date: '2024-05-15'
        },
        {
          title: 'Mantenimiento Programado',
          summary: 'Información sobre el próximo mantenimiento programado del sistema.',
          details: 'El mantenimiento está programado para el 2024-05-20 de 01:00 a 03:00 UTC. Durante este tiempo, algunos servicios no estarán disponibles.',
          date: '2024-05-20'
        }
      ]);
  
      const expandedIndex = ref(-1);
  
      function toggleDetails(index) {
        if (expandedIndex.value === index) {
          expandedIndex.value = -1;
        } else {
          expandedIndex.value = index;
        }
      }
  
      return { newsList, expandedIndex, toggleDetails };
    },
    mounted () {
      this.$refs.layoutRef.toggleProcesos()
      this.$refs.layoutRef.toggleReportes()
      this.$refs.layoutRef.toggleParametros()
      this.$refs.layoutRef.toggleAyuda()
    },
  };
  </script>
  
  <style scoped>
  .news-updates {
    max-width: 100%;
    margin: auto;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.1);
    padding: 20px;
    transition: all 0.3s ease-in-out;
    margin-top: 100px;
  }
  
  .news-item {
    margin-bottom: 15px;
    border-bottom: 1px solid #eaeaea; /* Lighter grey for subtle division */
    padding-bottom: 10px;
    transition: all 0.3s ease-in-out;
  }
  
  .news-summary {
    cursor: pointer;
    margin-bottom: 5px;
    transition: all 0.3s ease-in-out;
  }
  
  .news-summary h3 {
    font-size: 1.2em;
    color: #007BFF;
    margin-bottom: 5px;
    transition: color 0.3s ease-in-out;
  }
  
  .news-summary p {
    font-size: 1em;
    color: #5f6368; /* Dark grey for text for better readability */
    margin-bottom: 10px;
  }
  
  .toggle-details {
    display: block;
    margin-top: 10px;
    color: #9e9e9e; /* Medium grey for less important elements */
    font-style: italic;
    font-size: 0.9em;
    transition: all 0.3s ease-in-out;
  }
  
  .news-details {
    padding: 10px;
    background-color: #f7f7f7; /* Very light grey to distinguish details area */
    border-left: 4px solid #007BFF;
    margin-top: 5px;
    border-radius: 8px;
    transition: all 0.3s ease-in-out;
  }
  
  .news-date {
    text-align: right;
    font-style: italic;
    color: #737373; /* Soft grey for date and other metadata */
    margin-top: 10px;
    font-size: 0.9em;
  }
  </style>  